<template>
  <div>
    <h1>Biztosítás jellege</h1>

    <template>
      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="orszagkod_1-prepend">Induló ország</span>
            </div>

            <div class="flex-grow-1">
              <Select2
                id="orszagkod_1"
                name="orszagkod_1"
                v-model="fromCountry"
                :options="countries"
                :settings="{selectionCssClass: 'w-full'}"
              />
            </div>
          </div>

          <small id="orszagkod_1-error" class="text-danger input-alert"></small>
        </div>
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="orszagkod_2-prepend">Érkezési ország</span>
            </div>

            <div class="flex-grow-1">
              <Select2
                id="orszagkod_2"
                name="orszagkod_2"
                v-model="toCountry"
                :options="countries"
                :settings="{selectionCssClass: 'w-full'}"
              />
            </div>
          </div>

          <small id="orszagkod_2-error" class="text-danger input-alert"></small>
        </div>
      </div>

      <div>
        <div class="form-group row mb-3">
          <label class="col-sm-4">
            Biztosítás jellege <span class="text-danger">*</span>
            <span
              class="info"
              id="biztjelleg-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
              >?</span
            >
          </label>
          <div class="col-sm-8">
            <div class="row">
              <input type="text" hidden name="biztjelleg" :value="1" v-if="insuranceType == 1" />
              <input
                type="text"
                hidden
                name="biztjelleg"
                :value="2"
                v-else-if="insuranceType == 2"
              />
              <input
                type="text"
                hidden
                name="biztjelleg"
                :value="3"
                v-else-if="insuranceType == 3"
              />
              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="insuranceType = 1"
                  :class="{
                    'btn-red': insuranceType == 1,
                    'btn-outline-danger': insuranceType !== 1,
                  }"
                >
                  Egy útra
                </div>
              </div>
              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="insuranceType = 2"
                  :class="{
                    'btn-red': insuranceType == 2,
                    'btn-outline-danger': insuranceType !== 2,
                  }"
                >
                  Oda-vissza útra
                </div>
              </div>
              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="insuranceType = 3"
                  :class="{
                    'btn-red': insuranceType == 3,
                    'btn-outline-danger': insuranceType !== 3,
                  }"
                >
                  Több útra
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="form-group row mb-3">
          <label class="col-sm-4">Biztosítási feltétel <span class="text-danger">*</span></label>
          <div class="col-sm-8">
            <div class="row">
              <input type="text" hidden name="feltetel" :value="condition" />

              <div class="col-md-6 form-group mb-2">
                <div
                  class="btn w-100"
                  :class="{
                    'btn-red': condition === 'alt',
                    'btn-outline-danger no-hover': condition !== 'alt',
                  }"
                >
                  Általános feltétel
                </div>
              </div>
              <div class="col-md-6 form-group mb-2">
                <div
                  class="btn w-100"
                  :class="{
                    'btn-red': condition === 'nemz',
                    'btn-outline-danger no-hover': condition !== 'nemz',
                  }"
                >
                  Nemzetközi feltétel
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="form-group row mb-3">
          <label class="col-sm-4"
            >Biztosítási fedezet, záradék <span class="text-danger">*</span>
            <span
              class="info"
              id="zaradek-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
              >?</span
            ></label
          >
          <div class="col-sm-8 form-group">
            <select
              class="form-select"
              id="zaradek"
              name="zaradek"
              v-model="clause"
              required
              v-if="condition === 'alt'"
            >
              <option value="alt_a" v-if="shipmentType === 'uj'">All Risks záradék</option>
              <option value="alt_b">W.A. vagy W.P.A. záradék</option>
              <option value="alt_c">F.P.A. záradék</option>
            </select>

            <select
              class="form-select"
              id="zaradek"
              name="zaradek"
              v-model="clause"
              required
              v-else
            >
              <option value="nemz_a" v-if="shipmentType === 'uj'"
                >Institue Cargo Clauses (A) 1/1/82 CL. 252</option
              >
              <option value="nemz_b">Institue Cargo Clauses (B) 1/1/82 CL. 253</option>
              <option value="nemz_c">Institue Cargo Clauses (C) 1/1/82 CL. 254</option>
            </select>
          </div>
        </div>
      </div>
    </template>

    <h1 class="mt-4">Szállítmány adatai</h1>

    <template>
      <div>
        <div class="form-group row mb-3">
          <label class="col-sm-4">Szállított áru típusa <span class="text-danger">*</span></label>
          <div class="col-sm-8">
            <div class="row">
              <input type="text" hidden name="arutipus" :value="shipmentType" />

              <div class="col-md-6 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="shipmentType = 'uj'"
                  :class="{
                    'btn-red': shipmentType === 'uj',
                    'btn-outline-danger': shipmentType !== 'uj',
                  }"
                >
                  Új áru
                </div>
              </div>
              <div class="col-md-6 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="shipmentType = 'hasznalt'"
                  :class="{
                    'btn-red': shipmentType === 'hasznalt',
                    'btn-outline-danger': shipmentType !== 'hasznalt',
                  }"
                >
                  Használt áru
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="form-group row mb-3">
          <label class="col-sm-4">
            A Szerződés pénzneme <span class="text-danger">*</span>
            <span
              class="info"
              id="penznem-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
              >?</span
            >
          </label>
          <div class="col-sm-8">
            <div class="row">
              <input type="text" hidden name="penznem" :value="currency" />

              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="currency = 'huf'"
                  :class="{'btn-red': currency === 'huf', 'btn-outline-danger': currency !== 'huf'}"
                >
                  HUF
                </div>
              </div>
              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="currency = 'eur'"
                  :class="{'btn-red': currency === 'eur', 'btn-outline-danger': currency !== 'eur'}"
                >
                  EUR
                </div>
              </div>
              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="currency = 'usd'"
                  :class="{'btn-red': currency === 'usd', 'btn-outline-danger': currency !== 'usd'}"
                >
                  USD
                </div>
              </div>
            </div>
            <span v-if="currency === 'usd' || currency === 'eur'"
              ><small class="text-warning fw-bold"
                >Amennyiben a pénznem EUR vagy USD, online fizetési módnként csak átutalás
                választható!</small
              ></span
            >
          </div>
        </div>
      </div>

      <div class="form-group row mb-3">
        <label class="col-sm-4" for="aruertek"
          >Egy fuvareszközön szállítandó maximális áruérték <span class="text-danger">*</span>
          <span
            class="info"
            id="aruertek-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></label
        >
        <!-- @TODO: currency_min-t egyeztetni (melyik mező értékéhez kell-e kötni, már ha kell) -->
        <ValidationProvider
          :rules="{required: true, currency_min: 1, currency_max_product: parsedInsuranceAmount}"
          v-slot="{errors, classes}"
          class="col-sm-8"
        >
          <div class="input-group">
            <!-- @TODO: max értéket egyeztetni -->
            <input
              v-currency="{valueRange: {min: 1}}"
              class="form-control"
              id="aruertek"
              name="aruertek"
              :class="classes"
              aria-describedby="aruertek-prepend"
              v-model="shipmentValue"
            />
            <div class="input-group-append d-block">
              <span class="input-group-text" id="aruertek-prepend">{{ currencySymbol }}</span>
            </div>
          </div>
          <small id="aruertek-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

      <div class="form-group row mb-3">
        <label class="col-sm-4" for="biztosszeg"
          >Biztosítási összeg <span class="text-danger">*</span>
          <span
            class="info"
            id="biztosszeg-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></label
        >
        <!-- @TODO: currency_min-t egyeztetni (melyik mező értékéhez kell-e kötni, már ha kell) -->
        <ValidationProvider
          :rules="{
            required: true,
            currency_min: 1,
            currency_max: currency === 'huf' ? 60000000 : currency === 'eur' ? 150000 : 160000,
          }"
          v-slot="{errors, classes}"
          class="col-sm-8"
        >
          <div class="input-group">
            <!-- @TODO: max értéket egyeztetni -->
            <input
              v-currency="{valueRange: {min: 1}}"
              class="form-control"
              id="biztosszeg"
              name="biztosszeg"
              :class="classes"
              aria-describedby="biztosszeg-prepend"
              v-model="insuranceAmount"
            />
            <div class="input-group-append d-block">
              <span class="input-group-text" id="biztosszeg-prepend">{{ currencySymbol }}</span>
            </div>
          </div>
          <small id="biztosszeg-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

      <div class="form-group row mb-3">
        <label class="col-sm-4" for="arukategoria"
          >Árukategória
          <span
            class="info"
            id="arukategoria-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></label
        >
        <div class="col-sm-8">
          <select
            class="form-select"
            id="arukategoria"
            name="arukategoria"
            v-model="shipmentCategory"
            required
          >
            <option v-for="item in itemList" :key="item.id" :value="item.id">{{
              item.name
            }}</option>
          </select>
        </div>
      </div>

      <div class="form-group row mb-3">
        <label class="col-sm-4" for="arumegnevezese"
          >Biztosítandó áru megnevezése <span class="text-danger">*</span>
          <span
            class="info"
            id="arumegnevezese-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></label
        >

        <ValidationProvider :rules="{required: true}" v-slot="{errors, classes}" class="col-sm-8">
          <input
            class="form-control"
            id="arumegnevezese"
            name="arumegnevezese"
            v-model="shipmentName"
            aria-label="Áru megnevezése"
            aria-describedby="arumegnevezese-prepend"
            :class="classes"
          />

          <small id="arumegnevezese-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>

      <div class="form-group row mb-3">
        <label class="col-sm-4" for="karteritesialap"
          >Kártérítési alap
          <span
            class="info"
            id="karteritesialap-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></label
        >
        <div class="col-sm-8">
          <select
            class="form-select"
            id="karteritesialap"
            name="karteritesialap"
            v-model="compensationFund"
            required
          >
            <template v-if="shipmentType === 'uj'">
              <option value="uj_1">Az áru számla szerinti értéke</option>
              <option value="uj_2">Az áru számla szerinti értéke + 10% felülbiztosítás</option>
              <option value="uj_3"
                >Az áru számla szerinti értéke + fuvardíj + 10% felülbiztosítás</option
              >
            </template>
            <template v-else>
              <option value="hasznalt_1"
                >Műszaki avult (valóságos) érték, de max. az aktuális piaci avult érték</option
              >
              <option value="hasznalt_2">Utánpótlási / új érték</option>
            </template>
          </select>
        </div>
      </div>

      <div class="form-group row mb-3">
        <label class="col-sm-4">Szállítási mód <span class="text-danger">*</span></label>
        <div class="col-sm-8">
          <div class="row">
            <input type="text" hidden name="sz_gepjarmu" :value="hasVehicleTransport ? 1 : 0" />
            <input type="text" hidden name="sz_vasut" :value="hasTrainTransport ? 1 : 0" />
            <input type="text" hidden name="sz_hajo" :value="hasShipTransport ? 1 : 0" />
            <input type="text" hidden name="sz_repulo" :value="hasAirTransport ? 1 : 0" />
            <input type="text" hidden name="szallitasimod" :value="transportationMode" />

            <div class="col-md-3 form-group mb-2">
              <div
                class="btn w-100"
                @click="hasVehicleTransport = !hasVehicleTransport"
                :class="{
                  'btn-red': hasVehicleTransport,
                  'btn-outline-danger': !hasVehicleTransport,
                }"
              >
                Tehergépjármű
              </div>
            </div>
            <div class="col-md-3 form-group mb-2">
              <div
                class="btn w-100"
                @click="hasTrainTransport = !hasTrainTransport"
                :class="{'btn-red': hasTrainTransport, 'btn-outline-danger': !hasTrainTransport}"
              >
                Vasút
              </div>
            </div>
            <div class="col-md-3 form-group mb-2">
              <div
                class="btn w-100"
                @click="hasShipTransport = !hasShipTransport"
                :class="{'btn-red': hasShipTransport, 'btn-outline-danger': !hasShipTransport}"
              >
                Hajó
              </div>
            </div>
            <div class="col-md-3 form-group mb-2">
              <div
                class="btn w-100"
                @click="hasAirTransport = !hasAirTransport"
                :class="{'btn-red': hasAirTransport, 'btn-outline-danger': !hasAirTransport}"
              >
                Repülő
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div v-if="currency === 'huf'" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="onresz-prepend">Önrész</span>
            </div>
            <select
              class="form-select"
              id="onresz"
              name="onresz"
              v-model="deductibleAmount"
              required
              aria-label="Önrész"
              aria-describedby="onresz-prepend"
            >
              <option value="szazalek">10%, de min 100.000 HUF/kár</option>
              <option value="osszeg">100.000 HUF/kár</option>
              <option value="nincs">Nincs</option>
            </select>
          </div>

          <small id="onresz-error" class="text-danger input-alert"></small>
        </div>
        <div v-if="currency === 'usd'" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="onresz-prepend">Önrész</span>
            </div>
            <select
              class="form-select"
              id="onresz"
              name="onresz"
              v-model="deductibleAmount"
              required
              aria-label="Önrész"
              aria-describedby="onresz-prepend"
            >
              <option value="szazalek">10%, de min 300 USD/kár</option>
              <option value="osszeg">300 USD/kár</option>
              <option value="nincs">Nincs</option>
            </select>
          </div>

          <small id="onresz-error" class="text-danger input-alert"></small>
        </div>
        <div v-if="currency === 'eur'" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="onresz-prepend">Önrész</span>
            </div>
            <select
              class="form-select"
              id="onresz"
              name="onresz"
              v-model="deductibleAmount"
              required
              aria-label="Önrész"
              aria-describedby="onresz-prepend"
            >
              <option value="szazalek">10%, de min 300 EUR/kár</option>
              <option value="osszeg">300 EUR/kár</option>
              <option value="nincs">Nincs</option>
            </select>
          </div>

          <small id="onresz-error" class="text-danger input-alert"></small>
        </div>

        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="paritas-prepend">Paritás</span>
            </div>
            <input
              class="form-control"
              id="paritas"
              name="paritas"
              v-model="parity"
              aria-label="Paritás"
              aria-describedby="paritas-prepend"
            />
          </div>

          <small id="paritas-error" class="text-danger input-alert"></small>
        </div>

        <h1 class="h2 mt-4">Kockázatviselés időtartama</h1>
        <div class="row">
          <ValidationProvider
            :immediate="true"
            rules="required|kockazat_kezdet"
            v-slot="{errors}"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="kock_kezd-prepend"
                  >Kezdete: <span class="text-danger">*</span>
                  <span
                    class="info"
                    id="kock_kezd-tooltip"
                    data-toggle="tooltip"
                    data-placement="right"
                    title=""
                    >?</span
                  ></span
                >
              </div>

              <Datepicker
                id="kock_kezd"
                name="kock_kezd"
                class="flex-grow-1"
                :format="'yyyy-MM-dd'"
                :placeholder="'ÉÉÉÉ-HH-NN'"
                :language="hu"
                :disabled-dates="riskStartDisabledDates"
                :typeable="true"
                input-class="form-control"
                required
                v-model="insuranceStart"
                aria-label="Kockázatviselés kezdete"
                aria-describedby="kock_kezd-prepend"
              />

              <input type="text" name="kock_kezd" :value="insuranceStart" disabled hidden />
            </div>
            <small id="kock_kezd-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>

          <ValidationProvider
            :immediate="true"
            rules="required"
            v-slot="{errors}"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="kock_veg-prepend"
                  >Vége: <span class="text-danger">*</span>
                  <span
                    class="info"
                    id="kock_veg-tooltip"
                    data-toggle="tooltip"
                    data-placement="right"
                    title=""
                    >?</span
                  ></span
                >
              </div>

              <Datepicker
                id="kock_veg"
                name="kock_veg"
                class="flex-grow-1"
                :format="'yyyy-MM-dd'"
                :placeholder="'ÉÉÉÉ-HH-NN'"
                :language="hu"
                :typeable="true"
                input-class="form-control"
                required
                v-model="insuranceEnd"
                aria-label="Kockázatviselés vége"
                aria-describedby="kock_veg-prepend"
                :disabled-dates="{to: insuranceEndMinDate}"
              />

              <input type="text" name="kock_veg" :value="insuranceEnd" disabled hidden />
            </div>
            <small id="kock_veg-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>

        <h1 class="h2 mt-4">Díjfizetési mód</h1>
        <div class="form-group row mb-3">
          <label class="col-sm-4">Díjfizetés módja:</label>
          <div class="col-sm-8">
            <div class="row">
              <input type="text" hidden name="dijfizetes_mod" :value="paymentType" />

              <div class="col-md-6 form-group mb-2" v-if="currency !== 'usd' && currency !== 'eur'">
                <div
                  class="btn w-100"
                  @click="paymentType = 'online'"
                  :class="{
                    'btn-red': paymentType == 'online',
                    'btn-outline-danger': paymentType !== 'online',
                  }"
                >
                  Online
                </div>
              </div>
              <div class="col-md-6 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="paymentType = 'atutalas'"
                  :class="{
                    'btn-red': paymentType == 'atutalas',
                    'btn-outline-danger': paymentType !== 'atutalas',
                  }"
                >
                  Átutalás
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <OverallData v-if="insuranceYearlyPrice" />
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {mapFields} from 'vuex-map-fields';
import {hu} from 'vuejs-datepicker/dist/locale';
import Select2 from 'v-select2-component';
import OverallData from '../OverallData';
import {parse as parseMoney} from 'vue-currency-input';

export default {
  components: {
    Select2,
    Datepicker,
    OverallData,
  },
  data() {
    const now = new Date();

    return {
      hu,
      parsedInsuranceAmount: 0,
      riskStartDisabledDates: {
        customPredictor: function(date) {
          const maxDate = new Date().setDate(now.getDate() + 60);
          return date < now || date > maxDate;
        },
      },
    };
  },
  computed: {
    ...mapFields([
      'countries',
      'itemList',

      'insuranceType',
      'fromCountry',
      'toCountry',
      'condition',
      'clause',

      'shipmentType',
      'currency',
      'insuranceAmount',
      'shipmentValue',
      'shipmentCategory',
      'shipmentName',
      'compensationFund',
      'hasVehicleTransport',
      'hasTrainTransport',
      'hasShipTransport',
      'hasAirTransport',

      'deductibleAmount',
      'parity',

      'insuranceStart',
      'insuranceEnd',
      'paymentType',

      'insuranceYearlyPrice',
    ]),
    currencySymbol: {
      get() {
        const currencies = {huf: 'Ft', eur: '€', usd: '$'};

        return currencies[this.currency];
      },
    },
    transportationMode: {
      get() {
        let selectedCount = 0;

        if (this.hasVehicleTransport) selectedCount++;
        if (this.hasTrainTransport) selectedCount++;
        if (this.hasShipTransport) selectedCount++;
        if (this.hasAirTransport) selectedCount++;

        if (selectedCount >= 2) return 'kombinalt';

        if (this.hasVehicleTransport) return 'kozuti';
        if (this.hasTrainTransport) return 'vasuti';
        if (this.hasShipTransport) return 'vizi';
        if (this.hasAirTransport) return 'legi';

        return '';
      },
    },
    insuranceEndMinDate: {
      get() {
        const startDate = new Date(this.insuranceStart);

        return startDate;
      },
    },
  },
  watch: {
    toCountry: function() {
      this.checkConditionValue();
    },
    fromCountry: function() {
      this.checkConditionValue();
    },
    condition: function() {
      if (this.condition === 'nemz') {
        this.clause = 'nemz_a';

        if (this.shipmentType === 'hasznalt') {
          this.clause = 'nemz_b';
        }
      } else {
        this.clause = 'alt_a';

        if (this.shipmentType === 'hasznalt') {
          this.clause = 'alt_b';
        }
      }
    },
    shipmentType: function(newVal, oldVal) {
      if (newVal === oldVal) return;

      if (this.clause === 'alt_a') {
        this.clause = 'alt_b';
      } else if (this.clause === 'nemz_a') {
        this.clause = 'nemz_b';
      }

      if (newVal === 'uj') {
        return (this.compensationFund = 'uj_1');
      }

      this.compensationFund = 'hasznalt_1';
    },
    insuranceAmount: function(newVal) {
      this.parsedInsuranceAmount = parseMoney(newVal, window.currencyInputOptions) || 0;
    },

    currency: function(newVal) {
      if (newVal === 'usd' || newVal === 'eur') {
        this.paymentType = 'atutalas';
      }
    },
  },
  methods: {
    checkConditionValue() {
      if (this.fromCountry !== 'HU' || this.toCountry !== 'HU') {
        this.condition = 'nemz';
      } else {
        this.condition = 'alt';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn.no-hover:hover {
  cursor: auto;
  color: #dc3545 !important;
  background-color: unset !important;
}
</style>
